import { FC } from 'react';

import css from './EntryRewardsNameColumn.module.css';

import { ImageButton } from 'v2/components/imageButton/ImageButton';
import { EntryRewardModel } from 'v2/types/RewardModel';
import { fileSrc } from 'v2/utils';

interface EntryRewardsNameColumnProps {
  entryReward: EntryRewardModel;
}

export const EntryRewardsNameColumn: FC<EntryRewardsNameColumnProps> = ({ entryReward }) => (
  <div className={css.entryRewardsNameColumn}>
    <ImageButton src={fileSrc(entryReward.imageId)} alt={entryReward.title} />

    <p>{entryReward.title}</p>
  </div>
);
